import { BaseModel } from "../../abstracts/base.model"
import { ConnectionModel } from "../crm-model/connection.model";

export class CompanyModel extends BaseModel {
    CompanyID: string
    CompanyType: number = 2;
    Title: string
    CompanyName: string
    TaxOffice: string
    TaxNumber: string
    MersisNo: string
    IDCardNumber: string
    FirstName: string
    LastName: string
    Email: string
    Phone: string
    MobilePhone: string
    Fax: string
    WebSite: string
    Description: string
    CountryID: number = 213;
    ProvinceID: number
    DistrictID: number
    PostalCode: string
    Address: string
    isContact: boolean
    KepAddress: string

    Balance:number = 0;
    Total:number = 0;
    PaidTotal:number = 0;
    CompanyPhoto:string

}